"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMutation = void 0;
const react_query_1 = require("@tanstack/react-query");
const axios_1 = __importDefault(require("axios"));
const react_1 = require("react");
const useClient_1 = require("../../hooks/useClient/useClient");
const useErrorHandler_1 = require("../../hooks/useErrorHandler/useErrorHandler");
const useMutation = (mutation, options) => {
    const { axios: client } = (0, useClient_1.useClient)();
    const { handleError } = (0, useErrorHandler_1.useErrorHandler)();
    const mutationFn = (0, react_1.useCallback)((variables) => {
        const { endpoint, body, method, file, responseType } = mutation(variables);
        const axiosConfig = {
            url: endpoint,
            data: body ? (file ? body : JSON.stringify(body)) : undefined,
            method: method || 'POST',
            headers: {
                'Content-Type': file ? 'multipart/form-data' : 'application/json',
            },
            responseType,
        };
        return client.request(axiosConfig);
    }, [client, mutation]);
    const onError = (error, variables, context) => {
        if (options && !options.onError && options.handleErrorManually) {
            return;
        }
        if (!options || !options?.onError || !axios_1.default.isAxiosError(error)) {
            handleError({ error, omitAPIErrorMessage: options?.omitAPIErrorMessage });
            return;
        }
        return options.onError(error, variables, context);
    };
    return (0, react_query_1.useMutation)(mutationFn, { ...options, onError });
};
exports.useMutation = useMutation;
